'use client'

import { create } from 'zustand'

import { usePopupStore } from 'store/global/popup'
import { useDeviceStore } from 'store/server-context/device'

interface IState {
  viewCount: number
  previousPath: string
  increase: () => void
}
export const useViewCountStore = create<IState>((set, get) => ({
  viewCount: 0,
  previousPath: '',
  increase: () => {
    const isDownloadPopupOpen = usePopupStore.getState().mask.download
    if (isDownloadPopupOpen) {
      return
    }
    const previousPath = get().previousPath
    const currentPath = window.location.pathname
    if (previousPath !== currentPath) {
      set({ viewCount: 1, previousPath: currentPath })
      return
    }

    const viewCount = get().viewCount + 1
    set({ viewCount: viewCount })

    const showPopup = usePopupStore.getState().showDownloadPopup
    const device = useDeviceStore.getState().device

    // show download
    if (viewCount === 3 && device !== 'desktop') {
      showPopup()
      usePopupStore.subscribe(state => {
        if (!state.mask.download) {
          set({ viewCount: 0 })
        }
      })
    }
  }
}))
